import React, { useEffect, useState } from "react";
import axios from "axios";
import { Domain } from "Domain";
import {
  ArrowUp,
  FirstAidKit,
  Receipt,
  SignOut,
  SquaresFour,
  UsersThree,
} from "@phosphor-icons/react";

const styles = {
  page: {
    fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
    color: "#162033",
  },
  header: {
    marginBottom: "18px",
  },
  headerTitle: {
    fontSize: "22px",
    fontWeight: "800",
    color: "#162033",
    margin: "0 0 4px",
  },
  headerSub: {
    fontSize: "13px",
    color: "#7b8798",
    margin: "0",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "12px",
  },
  btnPrimary: {
    background: "#2f72f2",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "9px 16px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
  },
  btnGhost: {
    background: "#ffffff",
    color: "#2f72f2",
    border: "1px solid #dce8fb",
    borderRadius: "8px",
    padding: "9px 14px",
    fontSize: "13px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "7px",
    boxShadow: "none",
  },
  accountPill: {
    display: "flex",
    alignItems: "center",
    gap: "9px",
    background: "#ffffff",
    border: "1px solid #e1eaf6",
    borderRadius: "999px",
    padding: "6px 12px 6px 6px",
    color: "#162033",
    fontSize: "13px",
    fontWeight: "800",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "12px",
  },
  statCard: {
    background: "#ffffff",
    borderRadius: "8px",
    padding: "16px",
    border: "1px solid #e8eef7",
    boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    transition: "transform 0.2s, box-shadow 0.2s",
    cursor: "default",
  },
  statCardTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "14px",
  },
  statLabel: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#6c778a",
    margin: "0 0 2px",
  },
  statValue: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#162033",
    margin: "0",
    lineHeight: "1.2",
  },
  statIcon: {
    width: "30px",
    height: "30px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    flexShrink: 0,
  },
  statBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    fontWeight: "600",
    padding: "3px 8px",
    borderRadius: "999px",
    marginTop: "8px",
    width: "fit-content",
  },
  badgeUp: { background: "#e6f9f0", color: "#22c55e" },
  badgeDown: { background: "#fef2f2", color: "#ef4444" },
  badgeNeutral: { background: "#eff6ff", color: "#2f72f2" },
  mainGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 280px",
    gap: "12px",
    marginBottom: "12px",
  },
  card: {
    background: "#ffffff",
    borderRadius: "8px",
    padding: "16px",
    border: "1px solid #e8eef7",
    boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
  },
  cardTitle: {
    fontSize: "15px",
    fontWeight: "800",
    color: "#162033",
    margin: "0 0 14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tabRow: {
    display: "flex",
    gap: "4px",
    background: "#f4f7fb",
    borderRadius: "8px",
    padding: "3px",
  },
  tab: {
    padding: "5px 14px",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "500",
    cursor: "pointer",
    border: "none",
    background: "transparent",
    color: "#718096",
    transition: "all 0.15s",
  },
  tabActive: {
    background: "#ffffff",
    color: "#2f72f2",
    boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
  },
  chartArea: {
    height: "200px",
    display: "flex",
    alignItems: "flex-end",
    gap: "8px",
    borderTop: "1px solid #f0f4f8",
    paddingTop: "16px",
    marginTop: "4px",
  },
  chartBar: {
    flex: 1,
    borderRadius: "6px 6px 0 0",
    position: "relative",
    transition: "opacity 0.2s",
    cursor: "pointer",
    "&:hover": { opacity: 0.8 },
  },
  chartLabel: {
    fontSize: "11px",
    color: "#a0aec0",
    textAlign: "center",
    marginTop: "8px",
  },
  calendarCard: {
    background: "#ffffff",
    borderRadius: "8px",
    padding: "16px",
    border: "1px solid #e8eef7",
    boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
  },
  calHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  calTitle: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#162033",
  },
  calNav: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#7b8798",
    fontSize: "18px",
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": { background: "#f0f4f8" },
  },
  calGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: "4px",
    textAlign: "center",
  },
  calDayLabel: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#a0aec0",
    padding: "4px 0",
    textTransform: "uppercase",
  },
  calDay: {
    fontSize: "13px",
    padding: "6px 4px",
    borderRadius: "8px",
    cursor: "pointer",
    color: "#4a5568",
    fontWeight: "400",
    transition: "all 0.15s",
  },
  calDayToday: {
    background: "#2f72f2",
    color: "#fff",
    fontWeight: "700",
    boxShadow: "0 4px 12px rgba(26,115,232,0.3)",
  },
  calDayEmpty: { color: "transparent", cursor: "default" },
  bottomGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
  },
  tableWrap: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
  },
  th: {
    textAlign: "left",
    padding: "10px 14px",
    color: "#a0aec0",
    fontWeight: "600",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    borderBottom: "1px solid #f0f4f8",
  },
  td: {
    padding: "12px 14px",
    color: "#2d3748",
    borderBottom: "1px solid #f7f9fc",
    fontSize: "14px",
  },
  badge: {
    display: "inline-flex",
    padding: "3px 10px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
  },
  activityItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    padding: "12px 0",
    borderBottom: "1px solid #f7f9fc",
  },
  actDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginTop: "5px",
    flexShrink: 0,
  },
  actText: {
    fontSize: "13px",
    color: "#4a5568",
    margin: "0 0 3px",
    lineHeight: "1.5",
  },
  actTime: {
    fontSize: "11px",
    color: "#a0aec0",
    margin: "0",
  },
};

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function MiniCalendar() {
  const today = new Date();
  const [cur, setCur] = useState({
    y: today.getFullYear(),
    m: today.getMonth(),
  });
  const firstDay = new Date(cur.y, cur.m, 1).getDay();
  const daysInMonth = new Date(cur.y, cur.m + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const isToday = (d) =>
    d === today.getDate() &&
    cur.m === today.getMonth() &&
    cur.y === today.getFullYear();

  return (
    <div style={styles.calendarCard}>
      <div style={styles.calHeader}>
        <span style={styles.calTitle}>
          {MONTHS[cur.m]} {cur.y}
        </span>
        <div style={{ display: "flex", gap: "4px" }}>
          <button
            style={styles.calNav}
            onClick={() =>
              setCur((p) => ({
                y: p.m === 0 ? p.y - 1 : p.y,
                m: p.m === 0 ? 11 : p.m - 1,
              }))
            }
          >
            ‹
          </button>
          <button
            style={styles.calNav}
            onClick={() =>
              setCur((p) => ({
                y: p.m === 11 ? p.y + 1 : p.y,
                m: p.m === 11 ? 0 : p.m + 1,
              }))
            }
          >
            ›
          </button>
        </div>
      </div>
      <div style={styles.calGrid}>
        {DAYS.map((d) => (
          <div key={d} style={styles.calDayLabel}>
            {d[0]}
          </div>
        ))}
        {cells.map((d, i) => (
          <div
            key={i}
            style={{
              ...styles.calDay,
              ...(d === null ? styles.calDayEmpty : {}),
              ...(isToday(d) ? styles.calDayToday : {}),
            }}
          >
            {d || ""}
          </div>
        ))}
      </div>
    </div>
  );
}

const chartData = [
  { label: "Sun", val: 45, val2: 30 },
  { label: "Mon", val: 72, val2: 55 },
  { label: "Tue", val: 58, val2: 40 },
  { label: "Wed", val: 85, val2: 65 },
  { label: "Thu", val: 63, val2: 48 },
  { label: "Fri", val: 90, val2: 72 },
  { label: "Sat", val: 55, val2: 38 },
];
export default function Dashboard({ setLoggedin }) {
  const [activeTab, setActiveTab] = useState("Week");
  const [stats, setStats] = useState({
    totalDoctors: 0,
    totalClients: 0,
    totalBills: 0,
    totalModalities: 0,
  });
  const [recentActivity, setRecentActivity] = useState([]);
  const [dashboardRows, setDashboardRows] = useState([]);
  const [workloadChart, setWorkloadChart] = useState(chartData);

  useEffect(() => {
    const fetchActiveList = (endpoint, extras = {}) => {
      const formData = new FormData();
      formData.append("Status", "Active");
      Object.entries(extras).forEach(([key, value]) =>
        formData.append(key, value)
      );

      return axios({
        method: "post",
        url: Domain + endpoint,
        data: formData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      })
        .then((res) => (res.data && res.data.data ? res.data.data : []))
        .catch(() => []);
    };

    Promise.all([
      fetchActiveList("/GetAllDoctors.php"),
      fetchActiveList("/GetAllClients.php"),
      fetchActiveList("/GetAllModalities.php"),
      fetchActiveList("/GetAllPriceData.php", { Type: "CT" }),
      fetchActiveList("/GetAllPriceData.php", { Type: "MR" }),
    ]).then(([doctors, clients, modalities, ctPrices, mrPrices]) => {
      const priceItems = ctPrices.length + mrPrices.length;

      setStats({
        totalDoctors: doctors.length,
        totalClients: clients.length,
        totalBills: priceItems,
        totalModalities: modalities.length,
      });

      setDashboardRows([
        ...clients.slice(-2).map((client) => ({
          client: client.Name || client.Client || "Client",
          doctor: "Client registry",
          amount: "-",
          status: client.Status || "Active",
          statusColor: "#16833a",
          statusBg: "#ecfdf3",
        })),
        ...doctors.slice(-2).map((doctor) => ({
          client: doctor.Name || doctor.Doctor || "Doctor",
          doctor: "Doctor registry",
          amount: doctor.Pan || "-",
          status: doctor.Status || "Active",
          statusColor: "#2f72f2",
          statusBg: "#e8f0fe",
        })),
      ]);

      setRecentActivity([
        {
          text: `${doctors.length} active doctors available for billing`,
          time: "Live from registry",
          color: "#2f72f2",
        },
        {
          text: `${clients.length} active clients configured`,
          time: "Live from registry",
          color: "#16833a",
        },
        {
          text: `${modalities.length} modalities and ${priceItems} price items loaded`,
          time: "Live from tariff data",
          color: "#f59e0b",
        },
      ]);

      const source = [
        doctors.length,
        clients.length,
        modalities.length,
        ctPrices.length,
        mrPrices.length,
        priceItems,
        Math.max(doctors.length + clients.length, 1),
      ];

      setWorkloadChart(
        chartData.map((bar, index) => ({
          ...bar,
          val: Math.max(source[index], 1),
          val2: Math.max(Math.round(source[index] * 0.65), 1),
        }))
      );
    });
  }, []);

  const maxVal = Math.max(...workloadChart.map((d) => d.val), 1);

  const statCards = [
    {
      label: "Total Doctors",
      value: stats.totalDoctors || "—",
      icon: <FirstAidKit size={18} weight="duotone" color="#2f72f2" />,
      color: "#e8f0fe",
      iconBg: "#2f72f2",
      badge: "+1.5%",
      type: "up",
    },
    {
      label: "Total Clients",
      value: stats.totalClients || "—",
      icon: <UsersThree size={18} weight="duotone" color="#16833a" />,
      color: "#f0fdf4",
      iconBg: "#22c55e",
      badge: "+1.5%",
      type: "up",
    },
    {
      label: "Price Items",
      value: stats.totalBills || "—",
      icon: <Receipt size={18} weight="duotone" color="#a05a00" />,
      color: "#fef9e7",
      iconBg: "#f59e0b",
      badge: "+1.5%",
      type: "up",
    },
    {
      label: "Modalities",
      value: stats.totalModalities || "—",
      icon: <SquaresFour size={18} weight="duotone" color="#ef4444" />,
      color: "#fef2f2",
      iconBg: "#ef4444",
      badge: "Today",
      type: "neutral",
    },
  ];

  const recentBills = dashboardRows;

  const activities = recentActivity;

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerRow}>
          <div>
            <h1 style={styles.headerTitle}>Dashboard</h1>
            <p style={styles.headerSub}>
              Monitor billing, doctors, clients and radiology workload.
            </p>
          </div>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <div style={styles.accountPill}>
              <span
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  background: "#2f72f2",
                  color: "#ffffff",
                  display: "grid",
                  placeItems: "center",
                  fontSize: 12,
                }}
              >
                A
              </span>
              Admin
            </div>
            <button
              style={styles.btnGhost}
              onClick={() => setLoggedin && setLoggedin(undefined)}
            >
              <SignOut size={16} weight="bold" />
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Stat Cards */}
      <div style={styles.statsGrid}>
        {statCards.map((card, i) => (
          <div key={i} style={styles.statCard}>
            <div style={styles.statCardTop}>
              <div>
                <p style={styles.statLabel}>{card.label}</p>
                <p style={styles.statValue}>{card.value}</p>
              </div>
              <div style={{ ...styles.statIcon, background: card.color }}>
                <span style={{ fontSize: "22px", display: "flex" }}>
                  {card.icon}
                </span>
              </div>
            </div>
            <div
              style={{
                ...styles.statBadge,
                ...(card.type === "up"
                  ? styles.badgeUp
                  : card.type === "down"
                  ? styles.badgeDown
                  : styles.badgeNeutral),
              }}
            >
              {card.type === "up" && <ArrowUp size={13} weight="bold" />}
              {card.badge}
            </div>
          </div>
        ))}
      </div>

      {/* Main Grid: Chart + Calendar */}
      <div style={styles.mainGrid}>
        {/* Revenue Chart */}
        <div style={styles.card}>
          <div style={styles.cardTitle}>
            <span>Revenue Overview</span>
            <div style={styles.tabRow}>
              {["Week", "Month", "Year"].map((t) => (
                <button
                  key={t}
                  style={{
                    ...styles.tab,
                    ...(activeTab === t ? styles.tabActive : {}),
                  }}
                  onClick={() => setActiveTab(t)}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", gap: "20px", marginBottom: "12px" }}>
            <span
              style={{
                fontSize: "13px",
                color: "#2f72f2",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: "#2f72f2",
                  display: "inline-block",
                }}
              />
              Appointments
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#e8f0fe",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: "#93c5fd",
                  display: "inline-block",
                }}
              />
              Completed
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              gap: "10px",
              height: "180px",
              borderTop: "1px solid #f0f4f8",
              paddingTop: "16px",
            }}
          >
            {workloadChart.map((bar, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    height: "100%",
                    gap: "4px",
                  }}
                >
                  <div
                    style={{
                      width: "60%",
                      height: `${(bar.val2 / maxVal) * 100}%`,
                      background: "#93c5fd",
                      borderRadius: "4px 4px 0 0",
                      opacity: 0.7,
                    }}
                  />
                  <div
                    style={{ width: "60%", height: "0", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: `${(bar.val / maxVal) * 140}%`,
                        background: "#2f72f2",
                        borderRadius: "4px 4px 0 0",
                        transform: "translateY(-100%)",
                      }}
                    />
                  </div>
                </div>
                <span style={styles.chartLabel}>{bar.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Calendar */}
        <MiniCalendar />
      </div>

      {/* Bottom Grid: Recent Bills + Activity */}
      <div style={styles.bottomGrid}>
        {/* Recent Bills Table */}
        <div style={styles.card}>
          <div style={styles.cardTitle}>
            <span>Registry Snapshot</span>
            <span
              style={{
                fontSize: "13px",
                color: "#2f72f2",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              View All
            </span>
          </div>
          <div style={styles.tableWrap}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Client</th>
                  <th style={styles.th}>Doctor</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Status</th>
                </tr>
              </thead>
              <tbody>
                {recentBills.length === 0 ? (
                  <tr>
                    <td style={styles.td} colSpan="4">
                      No active registry data loaded yet.
                    </td>
                  </tr>
                ) : (
                  recentBills.map((row, i) => (
                    <tr key={i}>
                      <td style={styles.td}>
                        <strong>{row.client}</strong>
                      </td>
                      <td style={styles.td}>{row.doctor}</td>
                      <td style={styles.td}>
                        <strong>{row.amount}</strong>
                      </td>
                      <td style={styles.td}>
                        <span
                          style={{
                            ...styles.badge,
                            color: row.statusColor,
                            background: row.statusBg,
                          }}
                        >
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Activity Feed */}
        <div style={styles.card}>
          <div style={styles.cardTitle}>
            <span>Recent Activity</span>
            <span
              style={{
                fontSize: "13px",
                color: "#2f72f2",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              View All
            </span>
          </div>
          <div>
            {activities.map((act, i) => (
              <div key={i} style={styles.activityItem}>
                <div style={{ ...styles.actDot, background: act.color }} />
                <div>
                  <p style={styles.actText}>{act.text}</p>
                  <p style={styles.actTime}>{act.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
